import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input"]

    connect() {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        if (timeZone && this.hasInputTarget) {
            this.inputTarget.value = timeZone
        }
    }
}
